const MEDIA_ITEMS = [
  {
    title: '【独家】顶流男星深夜密会全记录：时间线梳理',
    desc: '从酒店监控到目击者证言，完整还原事件经过',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20abstract%20image%20with%20crimson%20red%20highlights%2C%20dramatic%20atmosphere%2C%20editorial%20quality%2C%20no%20text%2C%20no%20people&width=640&height=360&seq=media-1-91hl&orientation=landscape',
    duration: '12:35',
    views: '128w',
  },
  {
    title: '学术造假风波深度解读：从论文到学位全链条追踪',
    desc: '多位学术圈人士联合分析造假疑点与证据链',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20moody%20abstract%20editorial%20image%20with%20warm%20crimson%20accents%2C%20mysterious%20cinematic%20feel%2C%20fine%20art%20quality%2C%20no%20text%2C%20no%20people&width=640&height=360&seq=media-2-91hl&orientation=landscape',
    duration: '18:22',
    views: '96w',
  },
  {
    title: '综艺黑幕揭露：前选秀选手首次公开节目组潜规则',
    desc: '五位选手联合发声，披露选秀行业不为人知的秘密',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20abstract%20image%20in%20deep%20crimson%20and%20charcoal%2C%20cinematic%20lighting%2C%20editorial%20style%2C%20mysterious%20atmosphere%2C%20no%20text%2C%20no%20people&width=640&height=360&seq=media-3-91hl&orientation=landscape',
    duration: '22:10',
    views: '85w',
  },
  {
    title: '网红翻车实录：头部主播从巅峰到谷底全记录',
    desc: '盘点2026上半年翻车网红及其背后的资本链条',
    img: 'https://readdy.ai/api/search-image?query=An%20abstract%20editorial%20composition%20with%20warm%20crimson%20and%20dark%20tones%2C%20dramatic%20texture%2C%20artistic%20quality%2C%20mysterious%20vibe%2C%20no%20text%2C%20no%20people&width=640&height=360&seq=media-4-91hl&orientation=landscape',
    duration: '15:48',
    views: '72w',
  },
  {
    title: '吃瓜百科：娱乐圈常见黑料类型与辨别方法',
    desc: '教你如何在海量信息中分辨真假黑料，理性吃瓜不踩坑',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20abstract%20image%20with%20crimson%20red%20tonality%2C%20editorial%20style%2C%20mysterious%20and%20informative%20feel%2C%20fine%20art%20quality%2C%20no%20text%2C%20no%20people&width=640&height=360&seq=media-5-91hl&orientation=landscape',
    duration: '9:15',
    views: '63w',
  },
];

export default function Media() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-900">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-vidicon-line text-primary-400 mr-2"></i>
            视频专区
          </h2>
          <p className="mt-2 text-sm text-foreground-500">深度解读黑料事件，可视化吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {MEDIA_ITEMS.map((item, i) => (
            <div
              key={i}
              className={`group rounded-xl overflow-hidden bg-background-800/30 border border-background-700/40 hover:border-primary-500/20 transition-all duration-300 cursor-pointer ${
                i >= 3 ? 'lg:col-span-1' : ''
              }`}
            >
              {/* Thumbnail */}
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i >= 3 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/10 transition-colors"></div>
                {/* Play button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/85 backdrop-blur-sm group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300">
                    <i className="ri-play-fill text-background-950 text-xl ml-0.5"></i>
                  </div>
                </div>
                {/* Duration */}
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-background-950/75 backdrop-blur-sm text-foreground-300 text-xs font-medium">
                  {item.duration}
                </span>
              </div>

              {/* Info */}
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-200 group-hover:text-primary-300 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-600">
                  <span><i className="ri-eye-line mr-1"></i>{item.views}</span>
                  <span><i className="ri-time-line mr-1"></i>{item.duration}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}